// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BoundedGrid } from "./BoundedGrid";
import {
  BoundedGridFromJSON,
  BoundedGridFromJSONTyped,
  BoundedGridToJSON,
  BoundedGridToJSONTyped,
} from "./BoundedGrid";
import type { RangeType } from "./RangeType";
import {
  RangeTypeFromJSON,
  RangeTypeFromJSONTyped,
  RangeTypeToJSON,
  RangeTypeToJSONTyped,
} from "./RangeType";
import type { BoundedTimeAxis } from "./BoundedTimeAxis";
import {
  BoundedTimeAxisFromJSON,
  BoundedTimeAxisFromJSONTyped,
  BoundedTimeAxisToJSON,
  BoundedTimeAxisToJSONTyped,
} from "./BoundedTimeAxis";
import type { DType } from "./DType";
import { DTypeFromJSON, DTypeFromJSONTyped, DTypeToJSON, DTypeToJSONTyped } from "./DType";

/**
 *
 * @export
 * @interface RasterMeta
 */
export interface RasterMeta {
  /**
   *
   */
  grid?: BoundedGrid | null;
  /**
   *
   */
  time?: BoundedTimeAxis | null;
  /**
   * The data type of the raster as '{kind}{bytesize}'
   */
  dtype?: DType | null;
  /**
   * The value denoting no data, JSON encoded.
   */
  fillValue?: string | null;
  /**
   *
   */
  id: string;
  /**
   *
   */
  sourceId: string;
  /**
   *
   */
  rangeType: RangeType;
  /**
   *
   */
  wmsLayer: string;
  /**
   *
   */
  styleId: string;
  /**
   *
   */
  styleMinMax?: Array<any> | null;
}

/**
 * Check if a given object implements the RasterMeta interface.
 */
export function instanceOfRasterMeta(value: object): value is RasterMeta {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("sourceId" in (value as Record<string, any>)) &&
      !("source_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["sourceId"] === undefined &&
      (value as Record<string, any>)["source_id"] === undefined)
  )
    return false;
  if (
    (!("rangeType" in (value as Record<string, any>)) &&
      !("range_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["rangeType"] === undefined &&
      (value as Record<string, any>)["range_type"] === undefined)
  )
    return false;
  if (
    (!("wmsLayer" in (value as Record<string, any>)) &&
      !("wms_layer" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["wmsLayer"] === undefined &&
      (value as Record<string, any>)["wms_layer"] === undefined)
  )
    return false;
  if (
    (!("styleId" in (value as Record<string, any>)) &&
      !("style_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["styleId"] === undefined &&
      (value as Record<string, any>)["style_id"] === undefined)
  )
    return false;
  return true;
}

export function RasterMetaFromJSON(json: any): RasterMeta {
  return RasterMetaFromJSONTyped(json, false);
}

export function RasterMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): RasterMeta {
  if (json == null) {
    return json;
  }
  return {
    grid:
      json["grid"] === undefined
        ? undefined
        : json["grid"] === null
        ? null
        : BoundedGridFromJSON(json["grid"]),
    time:
      json["time"] === undefined
        ? undefined
        : json["time"] === null
        ? null
        : BoundedTimeAxisFromJSON(json["time"]),
    dtype:
      json["dtype"] === undefined
        ? undefined
        : json["dtype"] === null
        ? null
        : DTypeFromJSON(json["dtype"]),
    fillValue:
      json["fill_value"] === undefined
        ? undefined
        : json["fill_value"] === null
        ? null
        : json["fill_value"],
    id: json["id"],
    sourceId: json["source_id"],
    rangeType: RangeTypeFromJSON(json["range_type"]),
    wmsLayer: json["wms_layer"],
    styleId: json["style_id"],
    styleMinMax:
      json["style_min_max"] === undefined
        ? undefined
        : json["style_min_max"] === null
        ? null
        : json["style_min_max"],
  };
}

export function RasterMetaToJSON(json: any): RasterMeta {
  return RasterMetaToJSONTyped(json, false);
}

export function RasterMetaToJSONTyped(
  value?: RasterMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    grid: BoundedGridToJSON(value["grid"]),
    time: BoundedTimeAxisToJSON(value["time"]),
    dtype: DTypeToJSON(value["dtype"]),
    fill_value: value["fillValue"],
    id: value["id"],
    source_id: value["sourceId"],
    range_type: RangeTypeToJSON(value["rangeType"]),
    wms_layer: value["wmsLayer"],
    style_id: value["styleId"],
    style_min_max: value["styleMinMax"],
  };
}
